// Tab component override
export default function Tab(theme: any) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: '46px',
          color: theme.palette.text.primary,
          borderRadius: '8px',
          '&.Mui-selected': {
            color: theme.palette.primary.main
          }
        }
      }
    }
  };
}
